<template>
    <Head title="تیکت‌ها"/>
    <dashboard>
        <template v-slot:breadcrumb>
            <breadcrumb :links="[{title: 'تیکت‌ها'}]"/>
        </template>

        <div class="shadow p-4 rounded">
            <div class="mb-4">
                <Link href="/dashboard/tickets/create"
                      class="btn btn-primary bg-gradient-primary border-0 text-white btn-lg fw-bold fs-6 py-3 px-5">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
                            stroke="currentColor" stroke-width="1.5"/>
                        <path d="M14.5 12H9.5M12 14.5L12 9.5" stroke="currentColor" stroke-width="1.5"
                              stroke-linecap="round"/>
                    </svg>
                    ایجاد تیکت
                </Link>
            </div>

            <div class="vstack gap-4">
                <template v-for="ticket in tickets.data">
                    <div>
                        <div class="d-flex justify-content-between small p-3 rounded bg-light">
                            <div class="hstack gap-2">
                                <div v-if="ticket.latestMessage && ticket.latestMessage.is_admin"
                                     class="badge bg-warning text-black">
                                    پاسخ داده شده
                                </div>
                                <div v-else class="badge bg-secondary text-white">
                                    در انتظار پاسخ
                                </div>
                            </div>
                            <div class="hstack gap-2">
                                <div v-if="ticket.closed_at" class="">
                                    <span class="badge bg-dark text-white">بسته شده</span>
                                </div>
                                <div v-else class="">
                                    <span class="badge bg-info text-white">باز</span>
                                </div>
                                <div v-if="ticket.unread" class="">
                                    <span class="badge bg-danger text-white">جدید</span>
                                </div>
                                <div v-if="ticket.latestMessage" class="badge bg-white text-dark">
                                    {{ moment(ticket.latestMessage.created_at) }}
                                </div>
                            </div>
                        </div>
                        <div class="position-relative p-3">
                            <Link :href="`/dashboard/tickets/${ticket.uuid}`" class="stretched-link"></Link>
                            <h4 class="fw-bolder" :class="ticket.closed_at ? 'text-muted' : 'text-primary'">
                                {{ ticket.title }}</h4>
                            <div v-if="ticket.latestMessage" class="fs-6 text-truncate"
                                 :class="ticket.closed_at ?'text-muted' : 'text-dark'">
                                {{ $filters.strippedContent(ticket.latestMessage.message) }}
                            </div>
                        </div>
                    </div>
                </template>
            </div>

            <nav v-if="tickets.meta.last_page > 1">
                <ul class="pagination mb-0 mt-3">
                    <li v-for="link in tickets.meta.links" class="page-item" :class="{disabled: !link.url, active:link.active}">
                        <Link class="page-link" :href="link.url">
                            <span aria-hidden="true" v-html="link.label"></span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    </dashboard>
</template>

<script>
import Dashboard from "../../Layouts/Dashboard";
import Breadcrumb from "../../Components/Breadcrumb";
import {moment} from "../../helpers";

import {Head, Link} from '@inertiajs/inertia-vue3';

export default {
    components: {
        Dashboard,
        Breadcrumb,
        Head,
        Link,
    },
    props: {
        tickets: Object,
    },
    setup(props) {
        return {moment}
    }
}
</script>

<style scoped>

</style>
